import { defineAsyncComponent } from '../../../lib/utils/vue3compat/vue.js?vue3';
import { GlIcon, GlPopover, GlSkeletonLoader, GlTooltipDirective, GlAvatarsInline } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { n__ } from '~/locale';
import query from 'ee_else_ce/issuable/popover/queries/issue.query.graphql';
import IssueDueDate from '../../../boards/components/issue_due_date.vue?vue3';
import IssueMilestone from '../../components/issue_milestone.vue?vue3';
import StatusBadge from '../../components/status_badge.vue?vue3';
import { STATUS_CLOSED as ISSUABLE_STATUS_CLOSED } from '~/issues/constants';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import WorkItemTypeIcon from '../../../work_items/components/work_item_type_icon.vue?vue3';
import { findMilestoneWidget, findStartAndDueDateWidget, findAssigneesWidget, findWeightWidget, findStatusWidget } from '../../../work_items/utils.js?vue3';
import { STATE_CLOSED as WORK_ITEM_STATUS_CLOSED, WORK_ITEM_TYPE_NAME_EPIC } from '~/work_items/constants';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
export default {
    name: 'WorkItemPopover',
    components: {
        GlIcon,
        GlPopover,
        GlSkeletonLoader,
        GlAvatarsInline,
        IssueDueDate,
        IssueMilestone,
        IssueWeight: defineAsyncComponent(()=>import('../../../../../../ee/app/assets/javascripts/issues/components/issue_weight.vue?vue3')),
        IssueStatus: defineAsyncComponent(()=>import('../../../../../../ee/app/assets/javascripts/work_items/components/shared/work_item_status_badge.vue?vue3')),
        StatusBadge,
        WorkItemTypeIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        glFeatureFlagsMixin(),
        timeagoMixin
    ],
    props: {
        target: {
            type: [
                HTMLElement,
                Function,
                Object,
                String
            ],
            required: true
        },
        namespacePath: {
            type: String,
            required: true
        },
        iid: {
            type: String,
            required: true
        },
        cachedTitle: {
            type: String,
            required: false,
            default: ''
        },
        cachedTitleHtml: {
            type: String,
            required: false,
            default: ''
        },
        show: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            shouldFetch: false,
            workItem: null
        };
    },
    apollo: {
        workItem: {
            query,
            variables () {
                return {
                    fullPath: this.namespacePath,
                    iid: this.iid,
                    // We're reading the flag value additionally from `gon.features`
                    // as the component is mounted bare across GitLab when a work
                    // item is referenced in any GFM field (including Wikis), this
                    // ensures that popover query always sends the flag value to fetch
                    // correct sub-tree (i.e. `widgets[]` or `features`).
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField || window.gon?.features?.workItemFeaturesField)
                };
            },
            update: (data)=>data.namespace?.workItem,
            skip () {
                return !this.shouldFetch;
            }
        }
    },
    computed: {
        formattedTime () {
            const { createdAt } = this.workItem;
            return createdAt ? this.timeFormatted(createdAt) : '';
        },
        isIssueClosed () {
            return this.workItem?.state && [
                ISSUABLE_STATUS_CLOSED,
                WORK_ITEM_STATUS_CLOSED
            ].includes(this.workItem.state);
        },
        reference () {
            return this.workItemTypeName === WORK_ITEM_TYPE_NAME_EPIC ? this.workItem.fullReference?.replaceAll('#', '&') : this.workItem.fullReference;
        },
        workItemType () {
            return this.workItem?.workItemType || {};
        },
        workItemTypeName () {
            return this.workItemType?.name || '';
        },
        workItemTypeIcon () {
            return this.workItemType?.iconName || '';
        },
        assignees () {
            return findAssigneesWidget(this.workItem)?.assignees?.nodes || [];
        },
        assigneeAvatars () {
            return this.assignees.map((assignee)=>({
                    src: assignee.avatarUrl,
                    alt: assignee.name
                }));
        },
        moreAssigneesTooltip () {
            if (this.assignees.length > 2) {
                return n__('%d more assignee', '%d more assignees', this.assignees.length - 2);
            }
            return '';
        },
        datesWidget () {
            return findStartAndDueDateWidget(this.workItem) ?? {};
        },
        milestoneWidget () {
            return this.workItem?.features?.milestone ?? findMilestoneWidget(this.workItem) ?? {};
        },
        weightWidget () {
            return findWeightWidget(this.workItem) ?? {};
        },
        statusWidget () {
            return findStatusWidget(this.workItem) ?? {};
        }
    }
};
